// extracted by mini-css-extract-plugin
export default {"p":"Text_p__jbBCX","button":"Text_button__nD4ab"};